<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 md3 class="text-xs-center" px-1 mt-2>
        <v-flex class="date__picker">
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date"
                label="Date"
                prepend-icon="event"
                readonly
                v-on="on"
              />
            </template>
            <v-date-picker v-model="date" @input="menu = false"/>
          </v-menu>
        </v-flex>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="tableHeaders"
      :items="items"
      :loading="loadingInProgress"
      :no-data-text="loadingItemsText"
      :rows-per-page-items="rowsPerPageItems"
      :pagination.sync="pagination"
      :hide-actions="true"
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <td class="slotTime" :class="`${props.item.timeline}${checkInvolve(props.item.services)}`">{{ props.item.time }}</td>
        <td :class="`${props.item.timeline}${checkInvolve(props.item.services)}`">{{ props.item.start_time }}</td>
        <td :class="`${props.item.timeline}${checkInvolve(props.item.services)}`">{{ props.item.type }}</td>
        <td :class="`${props.item.timeline}${checkInvolve(props.item.services)}`">{{ props.item.case_manager }}</td>
        <td :class="`${props.item.timeline}${checkInvolve(props.item.services)}`">{{ getCaseCrew(props.item) }}</td>
        <td :class="`${props.item.timeline}${checkInvolve(props.item.services)}`">{{ props.item.description }}</td>
        <td :class="`${props.item.timeline}${checkInvolve(props.item.services)}`">{{ props.item.case_id }}</td>
      </template>
    </v-data-table>
    <AddScheduledCaseButton />
    <AddCaseNameAndDateDialog v-model="dialogModel" :date="dateForNewLead" @input="loadSchedules" v-if="dateForNewLead"/>
    <v-dialog
      v-model="showAlert"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text class="flex-center">
          <v-icon dark right class="notification-check">check_circle</v-icon> Staff has been notified. <v-icon dark left class="notification-cancel" @click="alert = false">cancel</v-icon>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  // import schedulesAPI from '@/api/resources/schedules'

  import AddScheduledCaseButton from '@/components/buttons/AddScheduledCaseButton'
  import AddCaseNameAndDateDialog from '@/components/dialogs/AddCaseNameAndDateDialog'

  export default {
    name: 'Cases',
    components: { AddScheduledCaseButton, AddCaseNameAndDateDialog },
    data () {
      return {
        items: [],
        tableHeaders: [
          { text: '', value: 'time' },
          { text: 'Time', value: 'start_time' },
          { text: 'Type', value: 'type' },
          { text: 'Case manager', value: 'users_id' },
          { text: 'Crew', value: 'crew' },
          { text: 'Description', value: 'description' },
          { text: 'Case ID', value: 'case_id' }
        ],
        rowsPerPageItems: [-1],
        pagination: {
          descending: true,
          rowsPerPage: -1,
          sortBy: 'created_at'
        },
        date: this.moment().format('YYYY-MM-DD'),
        menu: false,
        dateForNewLead: this.moment().format('YYYY-MM-DD'),
        dialogModel: false,
        services: [],
        loadingItemsText: 'Loading data...',
        loadingInProgress: true,
        showAlert: false
      }
    },
    watch: {
      date () {
        this.loadSchedules()
      }
    },
    provide: function () {
      return {
        onClickDate: this.onClickDate
      }
    },
    methods: {
      formatTime (date) {
        return date ? this.moment(date, 'YYYY-MM-DD HH:mm:ss').format('HH:mm') : '-'
      },
      getCaseType (item) {
        switch (item.status) {
          case 'pending':
            return 'Pickup'
          case 'approved':
            return 'Setup'
          case 'filled':
            return 'Wake'
          default:
            return 'Wake'
        }
      },
      getCaseCrew (item) {
        return item && item.services ? item.services.filter(i => i && i.description === 'Case Crew').map(i => i.name).join(', ') : ''
      },
      checkInvolve (services) {
        const userId = this.$store.getters.currentUser.id
        let result = ''
        if (services) {
          services.forEach(service => {
            if (service && service.users_id === userId) result = ' involved'
          })
        }
        return result
      },
      getTimelinePosition (time) {
        const diff = this.moment().diff(time, 'minutes')
        if (diff > 0 && diff < 60) return 'current'
        if (diff <= 0) return 'future'
        if (diff > 60) return 'past'
      },
      formTable (data) {
        const times = [...Array(24).keys()]
        const newData = []
        for (let k = 0; k < times.length; k++) {
          const time = times[k]
          const nextTime = time < 9 ? `0${time + 1}00` : time < 23 ? `${time + 1}00` : `2400`
          const currentTime = time <= 9 ? `0${time}00` : `${time}00`
          const timeItems = []
          for (let i = 0; i < data.length; i++) {
            const itemTime = data[i].start_time.replace(':', '')
            if (itemTime < nextTime && itemTime >= currentTime) timeItems.push(data[i])
          }
          if (timeItems.length === 0) {
            const timeline = this.getTimelinePosition(this.date + ' ' + currentTime.slice(0, -2) + ':00')
            timeItems.push({
              time: currentTime.slice(0, -2) + ':00',
              timeline: timeline,
              id: null,
              date: null,
              start_time: null,
              end_time: null,
              type: null,
              case_manager: null
            })
          } else {
            timeItems.sort((a, b) => {
              const timeA = parseInt(a.start_time.replace(':', ''))
              const timeB = parseInt(b.start_time.replace(':', ''))
              let comparison = 0
              if (timeA > timeB) {
                comparison = 1
              } else if (timeA < timeB) {
                comparison = -1
              }
              return comparison
            })
            timeItems[0].time = currentTime.slice(0, -2) + ':00'
          }
          newData[k] = timeItems
        }
        return newData.flat()
      },
      groupDataByCaseId (data) {
        const groupedData = []
        data.forEach(i => {
          if (i.cases_id) {
            if (groupedData[i.cases_id]) {
              groupedData[i.cases_id].services.push(i.service)
            } else {
              const timeline = this.getTimelinePosition(this.moment(i.schedule_start, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm'))
              groupedData[i.cases_id] = {
                time: '',
                timeline: timeline,
                id: i.id,
                leads_id: i.leads_id,
                item_id: i.item_id,
                case_id: i.cases_id,
                description: i.venue_description,
                date: this.moment(i.schedule_start, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
                start_time: this.moment(i.schedule_start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm'),
                end_time: i.schedule_end ? this.moment(i.schedule_end, 'YYYY-MM-DD HH:mm:ss').format('HH:mm') : '',
                type: 'Pickup',
                services: [i.service],
                case_manager: i.case ? i.case.manager_name : '-'
              }
            }
          }
        })
        return groupedData.filter(value => Object.keys(value).length !== 0)
      },
      loadSchedules () {
        this.loadingInProgress = true
        this.items = []
        this.$axios.get(`${this.$store.getters.config.api_host}/api/schedules/bydate?date=${this.date}`).then(response => {
          const result = response.data.additional_data
          const data = this.groupDataByCaseId(result.filter(i => i && this.moment(i.schedule_start, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') === this.date))
          this.items = this.formTable(data)
          this.loadingInProgress = false
        })
      },
      onClickDate (date) {
        if (this.$can('use', 'appointment-schedule-create-new-case')) {
          this.dateForNewLead = this.moment(date).subtract(1, 'month').format('YYYY-MM-DD')
          this.dialogModel = true
        }
      }
    },
    mounted () {
      this.loadSchedules()
      // const response = await this.$axios.get(`${this.$store.getters.config.api_host}api/schedules/bydate?date=2020-05-26`)
      this.showAlert = this.$route.params.alert
      setTimeout(() => {
        this.showAlert = false
      }, 2000)
    },
    props: {
      alert: {
        type: Boolean,
        default: false,
        required: false
      }
    }
  }
</script>

<style scoped>
.slotTime {
  font-weight: bold;
  color: rgba(119, 119, 119, 0.7);
}
td.past {
  background: #eee;
}
td.current {
  background: rgba(173, 216, 230, 0.4);
}
td.involved {
  background: rgba(110, 255, 0, 0.2);
}
.flex-center {
  display: flex;
  align-items: center;
}
.notification-check {
  margin-right: 10px;
  opacity: 0.5;
}
.notification-cancel {
  position: absolute;
  right: 0;
  opacity: 0.5;
}
.notification-cancel:hover {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// NewLeadTable.vue?59790082